export default Object.freeze({
  MANDATES: 0,
  COMPS: 1,
  PROPERTIES: 2,
  VALUATIONS: 3,
});
